/** 抬头管理接口：发票抬头 + 收票邮箱 */
import request from '@/utils/request';

const API_BASE = '/api/user/api/invoice_title';
const EMAIL_API_BASE = '/api/user/api/email';

function indivGet(url, params = {}) {
  return request.get(url, { params }).catch(() => null);
}

function indivPost(url, params = {}) {
  return request.post(url, null, { params });
}

export function fetchInvoiceTitleList() {
  return indivGet(`${API_BASE}/list`).then((data) => {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.list)) return data.list;
    return [];
  });
}

export function fetchDefaultInvoiceTitle() {
  return indivGet(`${API_BASE}/default`);
}

export function saveInvoiceTitle(payload = {}) {
  return indivPost(`${API_BASE}/save`, payload);
}

export function deleteInvoiceTitle(id) {
  return indivPost(`${API_BASE}/delete`, { id });
}

export function fetchEmailList() {
  return indivGet(`${EMAIL_API_BASE}/list`).then((data) => {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.list)) return data.list;
    return [];
  });
}

export function fetchDefaultEmail() {
  return indivGet(`${EMAIL_API_BASE}/default`);
}

export function saveEmail(payload = {}) {
  return indivPost(`${EMAIL_API_BASE}/save`, payload);
}

export function deleteEmail(id) {
  return indivPost(`${EMAIL_API_BASE}/delete`, { id });
}



// WEBPACK FOOTER //
// ./src/view/client/personal-center/panels/TitleManage/api.js